import { Box, Typography } from "@mui/material";

const AvailabilityDays = ({ days }) => {
  // Convert days to an array if it's not already
  const daysArray = Array.isArray(days) ? days : [];

  const allDays = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];
  const dayInitials = ["M", "T", "W", "T", "F", "S", "S"];

  return (
    <Box sx={{ display: "flex" }}>
      {allDays.map((day, index) => {
        const isAvailable = days[day] // Use daysArray instead of days
        return (
          <Typography
            key={day}
            sx={{
              mx: 0.5,
              color: isAvailable ? "#3B82F6" : "grey",
              fontWeight: isAvailable ? "bold" : "normal",
            }}
          >
            {dayInitials[index]}
          </Typography>
        );
      })}
    </Box>
  );
};

export default AvailabilityDays;
